import { render, staticRenderFns } from "./ManageProperties.vue?vue&type=template&id=52c7ead9&scoped=true&"
import script from "./ManageProperties.vue?vue&type=script&lang=js&"
export * from "./ManageProperties.vue?vue&type=script&lang=js&"
import style0 from "./ManageProperties.vue?vue&type=style&index=0&id=52c7ead9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c7ead9",
  null
  
)

export default component.exports